module.exports = __webpack_public_path__ + "static/img/no_address.30cf8405.png";